import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';

@Injectable()
export class ProfileInterceptor implements HttpInterceptor {
	constructor(
		private _authService: AuthenticationService
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

		if (this._authService.activeProfileId.value) {
			request = request.clone({
				setHeaders: {
					'X-Profile': this._authService.activeProfileId.value,
				},
			});
		}

		return next.handle(request);
	}
}
